export var FontSize;
(function (FontSize) {
  FontSize["HEADING1"] = "22px";
  FontSize["HEADING2"] = "18px";
  FontSize["HEADING3"] = "16px";
  FontSize["HEADING4"] = "14px";
  FontSize["HEADING5"] = "12px";
  FontSize["REGULAR"] = "14px";
  FontSize["SMALL"] = "12px";
})(FontSize || (FontSize = {}));